// extracted by mini-css-extract-plugin
module.exports = {"list":"Statistics_list__2GOij","item":"Statistics_item__3URfp"};